<template>
  <nav class="navbar has-background-dark">
    <div class="navbar-brand">
      <a href="/" class="navbar-item">
        <img class="logo" src="@/assets/images/minimal-logo.svg" alt="">
      </a>
      <a
        @click="toggleIsActive"
        role="button" class="navbar-burger has-text-light"
        :class="isActive"
        aria-label="menu"
        aria-expanded="false"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    <div class="navbar-menu" :class="isActive">
      <div class="navbar-start">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link has-text-light has-background-black">Orders</a>
          <div class="navbar-dropdown">
            <router-link
              v-if="role() === 'customer'"
              :to="{name: 'orders', params: {customerId: customerId()}}"
              class="navbar-item"
            >
              View Orders
            </router-link>
            <router-link
              v-if="role() === 'customer'"
              :to="{name: 'buyItems'}"
              class="navbar-item"
            >
              Place Orders
            </router-link>
          </div>
        </div>
        <div
          v-if="role() === 'rep' && ['salesperson', 'manager'].includes(salesRole())"
          class="navbar-item has-dropdown is-hoverable"
        >
          <a class="navbar-link has-text-light has-background-black" >Leads</a>
          <div class="navbar-dropdown">
            <router-link :to="{name: 'leads'}" class="navbar-item">
              View/Add Leads
            </router-link>
            <router-link :to="{name: 'calendar'}" class="navbar-item">
              View/Add Engagements
            </router-link>
          </div>
        </div>
        <a
          href="/customers"
          v-if="role() === 'rep'"
          class="navbar-item has-background-dark has-text-light"
        >
          Customers
        </a>
      </div>
      <div class="navbar-end">
        <div class="navbar-item" v-if="searchItems">
          <search></search>
        </div>
        <div class="navbar-item">
          <div v-if="isLoggedIn()" class="button">
            Hi {{username()}} <a @click.prevent="logOut">(log out)</a>
          </div>
          <a v-else href="/login" class="button is-primary">
            Log In
          </a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import router from '@/router';
import Search from '@/components/Search.vue';

export default {
  components: {
    search: Search,
  },
  props: {
    searchItems: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isActive: '',
    };
  },
  methods: {
    isLoggedIn() {
      console.log(localStorage.getItem('ed-authToken'));
      return localStorage.getItem('ed-authToken');
    },
    role() {
      return localStorage.getItem('ed-role');
    },
    salesRole() {
      return localStorage.getItem('ed-salesRole');
    },
    username() {
      return localStorage.getItem('ed-username');
    },
    customerId() {
      return localStorage.getItem('ed-customerId');
    },
    logOut() {
      console.log('logging out');
      localStorage.clear();
      router.push({ name: 'login' });
    },
    toggleIsActive() {
      this.isActive = this.isActive ? '' : 'is-active';
    },
  },
};
</script>


<style scoped>
nav {
  margin-bottom: 1rem;
}
.logo {
  filter: invert(100%);
}
</style>
